export default "__VITE_ASSET__DfKmyKqO__"